import React from "react";
import styles from "./view/PlaydateInviteRecipientView.module.css";
import { InviteStatus, PlaydateInvite } from "../../gql/types";
import { formatISODate } from "../time/TimeFormatter";
import TimeSelectionSelectionHeader from "../time/TimeSelectionSelectionHeader";
import TimeSelectionDisplayView from "../time/TimeSelectionDisplayView";
import { convertScheduleOptionsToDayPartSelections } from "../../service/playdate/converters/converter";

interface Props {
    invite: PlaydateInvite;
}

const PlaydateInviteFullDetails: React.FC<Props> = ({ invite }) => {

    return (
        <>
            <div className={styles.sectionHeader}>Title:</div>
            <div className={styles.title}>
                {invite.title}
            </div>
            <div className={styles.sectionHeader}>Location:</div>
            <div className={styles.title}>
                {invite.location}
            </div>
            {invite.status !== InviteStatus.Confirmed &&
                <>
                    <div className={styles.sectionHeader}>
                        <TimeSelectionSelectionHeader
                            key={"timeSelectionHeader"}
                            header={"Proposed Dates & Times"}
                        />
                    </div>
                    <TimeSelectionDisplayView
                        mode={"daypart"}
                        groupByDate={true}
                        daypartIconSelected={false}
                        selectedDayParts={convertScheduleOptionsToDayPartSelections(invite.scheduleOptions)}
                    />
                    {
                        invite.rsvpDeadline && (<>
                            <div className={styles.sectionHeader}>Respond By:</div>
                            <div className={styles.title}>
                                {formatISODate(invite.rsvpDeadline)}
                            </div></>)
                    }
                </>
            }
            {invite.status === InviteStatus.Confirmed && invite.finalScheduleOption &&
                <>
                    <div className={styles.sectionHeader}>
                        Date & Time:
                    </div>
                    <TimeSelectionDisplayView
                        mode={"daypart"}
                        groupByDate={false}
                        daypartIconSelected={false}
                        selectedDayParts={convertScheduleOptionsToDayPartSelections(invite.finalScheduleOption)}
                    />
                </>
            }
            <div className={styles.sectionHeader}>Details:</div>
            <div className={styles.notes}>
                {invite.details || <em>No message provided</em>}
            </div>
        </>
    );
};

export default PlaydateInviteFullDetails;
